<template>
    <div>
        <template v-if="customer">
            <v-card>
                <v-toolbar>
                    <v-toolbar-title class="toolbar-title">{{ customer.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <template v-slot:extension>
                        <v-tabs v-model="tab" align-with-title  color="#cf2e2e">
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab>
                                ALLMÄNT
                            </v-tab>
                            <v-tab>
                                KUNDPROJEKT {{ countProjects }}
                            </v-tab>
                            <v-tab>
                                OBJEKT {{ countAssets }}
                            </v-tab>
                            <v-tab>
                                PROTOKOLL {{ countForms }}
                            </v-tab>
                        </v-tabs>
                    </template>
                </v-toolbar>
                <v-tabs-items v-model="tab">
                    <v-tab-item transition="false">
                        <v-container class="details-container">
                            <v-row>
                                <v-col class="label">Kundnummer</v-col>
                                <v-col>{{ customerNumber }}</v-col>
                                <v-spacer></v-spacer>
                                <v-col class="label">Organisationsnummer</v-col>
                                <v-col>{{ customer.orgNumber }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col class="label">Kontakt</v-col>
                                <v-col>{{ customer.invoiceContact.name }}</v-col>
                                <v-spacer></v-spacer>
                                <v-col class="label">Momsregistreringsnummer</v-col>
                                <v-col>{{ customer.vatNumber }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col class="label">Telefonnummer</v-col>
                                <v-col>{{ customer.invoiceContact.phoneNo }}</v-col>
                                <v-spacer></v-spacer>
                                <v-col></v-col>
                                <v-col></v-col>
                            </v-row>
                            <v-row>
                                <v-col class="label">Email</v-col>
                                <v-col>{{ customer.invoiceContact.emailAddress }}</v-col>
                                <v-spacer></v-spacer>
                                <v-col></v-col>
                                <v-col></v-col>
                            </v-row>
                            <v-row>
                                <v-col class="label">Betalningsvillkor</v-col>
                                <v-col>{{ customer.termsOfPaymentDays }} dagar</v-col>
                                <v-spacer></v-spacer>
                                <v-col class="label">Fakturaadress</v-col>
                                <v-col style="white-space: pre-wrap;">{{ invoiceAddress }}</v-col>
                            </v-row>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item transition="false">
                        <div>
                            <v-container class="details-container">
                                <v-row class="header-row">
                                    <v-col>Projektnamn</v-col>
                                    <v-col>Projektnummer</v-col>
                                    <v-col>Beskrivning</v-col>
                                    <v-col>Referensnummer</v-col>
                                </v-row>
                                <v-row v-for="(project, index) in customer.projects" :key="project.id" @click="clickCustomerProject(project.id)" :class="index % 2 != 0 ? 'row-background' : ''">
                                    <v-col>{{ project.name }}</v-col>
                                    <v-col v-if="project.projectNo">{{ project.projectNo }}</v-col><v-col v-else>{{ project.projectNoText }}</v-col>
                                    <v-col>{{ project.description }}</v-col>
                                    <v-col>{{ project.referenceNo }}</v-col>
                                </v-row>
                            </v-container>
                        </div>
                    </v-tab-item>
                    <v-tab-item transition="false">
                        <div>
                            <v-container class="details-container">
                                <v-row>
                                    <v-col>
                                        <select @change="assetLabelFilter($event)">
                                            <option value="-1">Alla etiketter</option>
                                            <option v-for="label in labels" :key="label" :value="label">{{ label }}</option>
                                        </select>
                                    </v-col>
                                    <v-col>
                                        <select @change="assetStateFilter($event)">
                                            <option value="all">Alla status</option>
                                            <option value="IN_USE">I drift</option>
                                            <option value="OUT_OF_ORDER">Ur funktion</option>
                                        </select>
                                    </v-col>
                                    <v-col>
                                        <select @change="assetTypeFilter($event)">
                                            <option value="-1">Alla objekttyper</option>
                                            <option v-for="type in assetTypes" :key="type" :value="type">{{ type }}</option>
                                        </select>
                                    </v-col>
                                    <v-col>
                                        <select @change="assetProjectFilter($event)">
                                            <option value="-1">Alla kundprojekt</option>
                                            <option value="none">Inga kundprojekt</option>
                                            <option v-for="name in customerProjectsNames" :key="name" :value="name">{{ name }}</option>
                                        </select>
                                    </v-col>
                                </v-row>
                                <v-row class="header-row">
                                    <v-col>Objektnamn</v-col>
                                    <v-col>Objektnummer</v-col>
                                    <v-col>Etiketter</v-col>
                                    <v-col>Status</v-col>
                                    <v-col>Kundprojekt</v-col>
                                    <v-col>Plats</v-col>
                                </v-row>
                                <v-row v-for="(asset, index) in filteredAssets" :key="asset.id" @click="clickAsset(asset.id)" :class="index % 2 != 0 ? 'row-background' : ''">
                                    <v-col>{{ asset.name }}</v-col>
                                    <v-col>{{ asset.assetNo }}</v-col>
                                    <template v-if="asset.labels">
                                        <v-col>{{ asset.labels.join(' ')}}</v-col>
                                    </template>
                                    <template v-else>
                                        <v-col></v-col>
                                    </template>
                                    <v-col>{{ asset.status }}</v-col>
                                    <v-col>{{ asset.customerProjectName }}</v-col>
                                    <v-col v-if="asset.location">{{ asset.location.placeName }}</v-col><v-col v-else></v-col>
                                </v-row>
                            </v-container>
                        </div>
                    </v-tab-item>
                    <v-tab-item transition="false">
                        <div>
                            <v-container class="details-container">
                                <v-row><!--
                                    <v-col v-if="formTypes.includes('Shopinformation')">
                                        <select @change="filterManagerPresent($event)">
                                            <option value="all">CSM bägge</option>
                                            <option value="yes">CSM närvarande: Ja</option>
                                            <option value="no">CSM närvarande: Nej</option>
                                        </select>
                                    </v-col>-->
                                    <v-col>
                                        <select @change="filterFormType($event)">
                                            <option value="-1">Alla protokoll</option>
                                            <option v-for="type in formTypes" :key="type" :value="type">{{ type }}</option>
                                        </select>
                                    </v-col>
                                    <v-col>
                                        <select @change="formProjectFilter($event)">
                                            <option value="-1">Alla kundprojekt</option>
                                            <option value="none">Inga kundprojekt</option>
                                            <option v-for="name in customerProjectsNames" :key="name" :value="name">{{ name }}</option>
                                        </select>
                                    </v-col>
                                </v-row>
                                <v-row  class="header-row">
                                    <v-col>Datum</v-col>
                                    <!--<v-col>Status</v-col>-->
                                    <v-col>Titel</v-col>
                                    <v-col>Kundprojekt</v-col>
                                </v-row>
                                <v-row v-for="(form, index) in filteredForms" :key="form.id" @click="clickForm(form.id)" :class="index % 2 != 0 ? 'row-background' : ''">
                                    <v-col>{{ form.date }}</v-col>
                                    <!--<v-col>{{ form.state }}</v-col>-->
                                    <v-col>{{ form.title }}</v-col>
                                    <v-col><template v-if="form.customerProjectNo">{{ form.customerProjectNo }}</template><template v-else>{{ form.customerProjectNoText }}</template> {{ form.customerProjectName }}</v-col>
                                </v-row>
                            </v-container>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </template>
        <template v-else>
            <h1>Hi normal user</h1>
        </template>
        <div v-if="this.loading">
            <v-progress-linear
                indeterminate
                color="primary"
                height="2">
            </v-progress-linear>
        </div>
        <div class="footer" style="margin-top:25px">
            <span class="version">v. {{ version }}</span>
            <span class="powered-by">
                <span class="bollar-container">
                    <a href="https://www.coredination.se/"><img class="bollar" src="/img/bollar.png"/></a>
                </span>
                <span>
                    <a href="https://www.coredination.se/">Powered by Coredination</a>
                </span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    'name': 'Customer',
    props: [],
    created() {
        this.setupData();
    },
    mounted() {
        this.setupForms();
        this.setupAssets();
        this.filterAssets();
        this.filterForms();
    },
    data: () => ({
        loading: false,
        customer: null,
        assets: [],
        forms: [],
        tab: null,
        tabs: ['Allmänt','Kundprojekt','Objekt','Protokoll'],
        filteredAssets: [],
        filter: { asset: {}, form: {}},
        filteredForms: []
    }),
    beforeRouteEnter(to, from, next) {
        // Go to tab depending on where you come from
        if (from.name == 'FormDetails') {
            next( vm => {
                vm.tab = 3;
            });
        } else if (from.name == 'AssetDetails') {
            next( vm => {
                vm.tab = 2;
            });
        } else if (from.name == 'Project') {
            next( vm => {
                vm.tab = 1;
            });
        } else next();
    }
    ,
    methods: {
        setupData() {
            this.customer = this.$customer;
            this.assets = this.$assets;
            this.forms = this.$forms;
        },
        clickCustomerProject(id) {
            let project = this.customer && this.customer.projects && this.customer.projects.find(project => project.id == id);
            let assets = this.assets && this.assets.filter(asset => asset.customerProjectId == id);
            let forms = this.forms && this.forms.filter(form => form.customerProjectId == id)
            this.$router.push({ name: 'Project', params: { projectData: project, projectAssets: assets, projectForms: forms, id: id }});
        },
        clickAsset(id) {
            let asset = this.assets && this.assets.find(asset => asset.id == id);
            this.$router.push({ name: 'AssetDetails', params: { asset: asset, id: id }});
        },
        clickForm(id) {
            //let form = this.forms && this.forms.find(form => form.id == id);
            this.$router.push({ name: 'FormDetails', params: { formId: id, id: id }});
        },
        setupForms() {
            if (!this.forms) return;
            this.forms.forEach(form => {
                form.date = new Date(form.creationTimeStamp).toISOString().substr(0,10);
            });
        },
        setupAssets() {
            if (!this.assets) return;
            this.assets.forEach(asset => {
                asset.status = asset.state == 'OUT_OF_ORDER' ? 'Ur funktion' : 'I drift';
            });
        },
        assetLabelFilter(event) {
            let filter = event.target.value;
            if (filter == '-1') this.filter.asset.label = null;
            else this.filter.asset.label = filter;
            this.filterAssets();
        },
        assetTypeFilter(event) {
            let filter = event.target.value;
            if (filter == '-1') this.filter.asset.assetType = null;
            else this.filter.asset.assetType = filter;
            this.filterAssets();
        },
        assetProjectFilter(event) {
            let filter = event.target.value;
            if (filter == '-1') this.filter.asset.project = null;
            else this.filter.asset.project = filter;
            this.filterAssets();
        },
        assetStateFilter(event) {
            let filter = event.target.value;
            if (filter == 'all') this.filter.asset.state = null;
            else this.filter.asset.state = filter;
            this.filterAssets();
        },
        filterAssets() {
            let filteredAssets = JSON.parse(JSON.stringify(this.assets));
            if (this.filter.asset.label) {
                filteredAssets = filteredAssets.filter(asset => asset.labels.includes(this.filter.asset.label));
            }
            if (this.filter.asset.assetType) {
                filteredAssets = filteredAssets.filter(asset => asset.assetTypeName == this.filter.asset.assetType);
            }
            if (this.filter.asset.project) {
                if (this.filter.asset.project == 'none') filteredAssets = filteredAssets.filter(asset => asset.customerProjectName == null);
                else filteredAssets = filteredAssets.filter(asset => asset.customerProjectName == this.filter.asset.project);
            }
            if (this.filter.asset.state) {
                if (this.filter.asset.state != 'all') {
                    filteredAssets = filteredAssets.filter(asset => asset.state == this.filter.asset.state);
                }
            }
            this.filteredAssets = filteredAssets;
        },
        filterManagerPresent(event) {
            let filter = event.target.value;
            if (filter == 'all') this.filter.form.manager = null;
            else this.filter.form.manager = filter;
            this.filterForms();
        },
        filterFormType(event) {
            let filter = event.target.value;
            if (filter == '-1') this.filter.form.type = null;
            else this.filter.form.type = filter.toLowerCase();
            this.filterForms();
        },
        formProjectFilter(event) {
            let filter = event.target.value;
            if (filter == '-1') this.filter.form.project = null;
            else this.filter.form.project = filter;
            this.filterForms();
        },
        filterForms() {
            let filteredForms = JSON.parse(JSON.stringify(this.forms));
            if (this.filter.form.manager) {
                if (this.filter.form.manager == 'yes') filteredForms = filteredForms.filter(form => form.title.toLowerCase().includes('närvarande: ja'));
                else if (this.filter.form.manager == 'no') filteredForms = filteredForms.filter(form => form.title.toLowerCase().includes('närvarande: nej'));
            }
            if (this.filter.form.type) {
                filteredForms = filteredForms.filter(form => form.title && form.title.toLowerCase().includes(this.filter.form.type));
            }
            if (this.filter.form.project) {
                if (this.filter.form.project == 'none') filteredForms = filteredForms.filter(form => form.customerProjectName == null);
                else filteredForms = filteredForms.filter(form => form.customerProjectName == this.filter.form.project);
            }
            this.filteredForms = filteredForms;
        }
    },
    computed: {
        assetTypes() {
            return [...new Set(this.assets.map(asset => asset.assetTypeName))];
        },
        labels() {
            let labels = [];
            this.assets.forEach(asset => {
                if (asset.labels && asset.labels.length > 0) {
                    asset.labels.forEach(label => {
                        if (!labels.includes(label)) labels.push(label);
                    });
                }
            });
            return labels;
        },
        customerNumber() {
            return this.customer.customerNo || this.customer.customerNoText
        },
        customerProjectsNames() {
            return [...new Set(this.customer.projects.map(project => project.name))];
        },
        version () {
            return this.$version;
        },
        countProjects() {
            return '(' + this.customer.projects.length + ')';
        },
        countAssets() {
            return '(' + this.assets.length + ')';
        },
        countForms() {
            return '(' + this.forms.length + ')';
        },
        invoiceAddress() {
            let invoiceAddress = this.customer.invoiceAddress;
            let address = invoiceAddress.address1 + '\n' + (invoiceAddress.address2 ? (invoiceAddress.address2 + '\n') : '') + invoiceAddress.postalCode + ' ' + invoiceAddress.city + '\n' + (invoiceAddress.country == 'se' ? 'Sweden' : invoiceAddress.country.toUpperCase());
            return address;
        },
        formTypes() {
            return [...new Set(this.forms.map(function(form) {
                if (form.title && form.title.toLowerCase().includes('shopinformation')) return 'Shopinformation';
                else if (form.title) return form.title;
            }))];
        }

    },
    components: {
    }
}
</script>

<style lang="scss" scoped>
    .label {
        color: grey;
        text-align: right;
    }
    select {
        border: 1px solid grey;
        border-radius: 2px;
    }
</style>